import React from "react";
import "../src/css/index.css";
import "../src/css/margins.css";
import App from "./App";
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.js";
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

// Global error handler for MSAL and other unhandled errors
const errorHandler = (event) => {
  if (event.error && event.error.message) {
    // Check if it's an MSAL error
    if (event.error.message.includes('MSAL') || 
        event.error.name === 'BrowserAuthError' ||
        event.error.name === 'ClientAuthError') {
      console.error('MSAL Error:', event.error);
      // Here you could also show a UI notification about the error
    } else {
      console.error('Unhandled error:', event.error);
    }
  }
};

// Add global error handlers
window.addEventListener('error', errorHandler);
window.addEventListener('unhandledrejection', (event) => {
  errorHandler({ error: event.reason });
});

// Set MSAL debug mode if needed
if (process.env.NODE_ENV === 'development') {
  window.localStorage.setItem('msal.browser.debug', 'true');
}

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);